import type { ComponentType } from "react";

import type { View } from "@/features/views";
import { useActiveView } from "@/features/views/hooks/useActiveView";

type Props = {
    views: Partial<Record<View, ComponentType>>;
    fallback: ComponentType;
};

/**
 * Selects a full page component for the user's effective active view.
 *
 * Renders `fallback` when the new permission system is off for the user, or when no page is
 * registered for the active view.
 *
 * Note: This is not a permission/access boundary, it only picks composition.
 */
const ViewPage = (props: Props) => {
    const { views, fallback: Fallback } = props;

    const activeView = useActiveView();
    const ViewComponent = activeView ? views[activeView] : undefined;

    if (!ViewComponent) {
        return <Fallback />;
    }

    return <ViewComponent />;
};

export { ViewPage };
